import SDatePicker from 'components/SDatePicker';
import QDateRangePicker, { type QDateRangePickerProps } from './QDateRangePicker';
import React from 'react';

type DatePickerProps = QDateRangePickerProps & {
  range?: boolean;
  dateRange?: string;
  format?: string;
};

const DatePicker = (props: DatePickerProps) => {
  const { range } = props;

  // QDatePicker routes date range selection QDateRangePicker_V2 and single date selection to SDatePicker
  if (range) {
    return <QDateRangePicker {...props} />;
  }

  const adpatedProps = { ...props, onChange: props.onSelect }; // map onSelect() to onChange()
  // @ts-expect-error FIXME TS2322
  return <SDatePicker {...adpatedProps} />;
};

export default DatePicker;
